import React from 'react';
import get from 'lodash/get';

import RichText from '../../../components/atoms/RichText';
import Container from '../../../components/molecules/Container';
import Grid from '../../../components/molecules/Grid';

import * as locators from './locators';
import useStyles from './style';
import Typography from '../../../components/atoms/Typography';

const EditorialText = props => {
  const description = get(props, 'fields.description', '');
  const classes = useStyles();
  return description && description.value ? (
    <Container data-locator={locators.COMPONENT_NAME} className={classes.root}>
      <Grid>
        <Typography component="div" variant="body1">
          <RichText innerHTML={description} className='player-wrapper' />
        </Typography>
      </Grid>
    </Container>
  ) : null;
};

export default EditorialText;
